import { useMemo } from 'react';
import { RefPermissionEnum } from '@trinity/management-app-client/enums';
import { useAppSelector } from '@/store';

export const useBrandInsightsCapabilities = () => {

  const author = useAppSelector(state => state.user);

  return useMemo(() => {
    if (!author?.permissions) {
      return {
        canApplyFilters: false,
        canViewTraces: false,
        canViewExternalLinks: false,
        canViewMetadata: false,
      };
    }

    return {
      canApplyFilters: author.permissions.includes(RefPermissionEnum.ApplyFilters),
      canViewTraces: author.permissions.includes(RefPermissionEnum.ViewChatTraces),
      canViewExternalLinks: true,
      canViewMetadata: author.permissions.includes(RefPermissionEnum.ViewQueryMetadata),
    };
  }, [author?.permissions]);
};